// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store.js'
import BootstrapVue from 'bootstrap-vue'
import firebase from 'firebase'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import Vuelidate from 'vuelidate'
import i18n from './lang/lang.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import VCalendar from 'v-calendar'
import VueMonthlyPicker from './components/VueMonthlyPicker'
import draggable from 'vuedraggable'

// const firebaseConfig = {
//   apiKey: 'AIzaSyAIhO_5zUPaql--YjD1yCc4vSrA2DaJUik',
//   authDomain: 'memo-chef-dev.firebaseapp.com',
//   databaseURL: 'https://memo-chef-dev.firebaseio.com',
//   projectId: 'memo-chef-dev',
//   functionsHostName: 'https://us-central1-memo-chef-dev.cloudfunctions.net',
//   storageBucket: 'memo-chef-dev.appspot.com',
//   messagingSenderId: '163819277804',
//   appId: '1:163819277804:web:a75f2e1da8425b4a',
//   measurementId: 'G-KS3P55SKBZ'
// }

const firebaseConfig = {
  apiKey: 'AIzaSyCiWTtFXuEtNqnHMV22hmDwXLVPSEs-auQ',
  authDomain: 'memo-project-61c28.firebaseapp.com',
  databaseURL: 'https://memo-project-61c28.firebaseio.com',
  projectId: 'memo-project-61c28',
  functionsHostName: 'https://us-central1-memo-project-61c28.cloudfunctions.net',
  storageBucket: 'memo-project-61c28.appspot.com',
  messagingSenderId: '337424788002',
  appId: '1:337424788002:web:adefc84afdc66c88',
  measurementId: 'G-WYW9WRGLTJ'
}

export const fireApp = firebase.initializeApp(firebaseConfig)
export const AUTH = fireApp.auth()
firebase.analytics()

Vue.prototype.$firebase = firebase

firebase.auth().onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !store.state.user.loggedIn) next({name: 'LogIn'})
  else next()
})

Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VCalendar)
Vue.component('multiselect', Multiselect)
Vue.component('vue-monthly-picker', VueMonthlyPicker)
Vue.component('draggable', draggable)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js